// _forms/_shared/components/BannerRenderer.jsx
import React from 'react';
import './BannerRenderer.css';

const BannerRenderer = ({ content, className = '' }) => {
    if (!content) return null;
  
    // Función para detectar y convertir URLs en enlaces
// BannerRenderer con soporte markdown básico
const convertUrlsToLinks = (text) => {
    if (!text) return text;
  
    // Primero, convertir markdown [texto](url)
    const markdownRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    let processed = text;
    const parts = [];
    let lastIndex = 0;
    let match;
  
    // Buscar enlaces markdown
    while ((match = markdownRegex.exec(text)) !== null) {
      const fullMatch = match[0];
      const linkText = match[1];
      const url = match[2];
      const start = match.index;
      const end = start + fullMatch.length;
  
      if (start > lastIndex) {
        parts.push({ type: 'text', content: text.substring(lastIndex, start) });
      }
  
      const hasProtocol = url.startsWith('http://') || url.startsWith('https://');
      const href = hasProtocol ? url : `https://${url}`;
  
      parts.push({
        type: 'link',
        content: linkText,
        href: href
      });
  
      lastIndex = end;
    }
  
    // Si no hay enlaces markdown, buscar URLs normales
    if (parts.length === 0) {
      const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.[a-zA-Z]{2,}[^\s]*)/gi;
      while ((match = urlRegex.exec(text)) !== null) {
        const url = match[0];
        const start = match.index;
        const end = start + url.length;
  
        if (start > lastIndex) {
          parts.push({ type: 'text', content: text.substring(lastIndex, start) });
        }
  
        const hasProtocol = url.startsWith('http://') || url.startsWith('https://');
        const href = hasProtocol ? url : `https://${url}`;
  
        parts.push({
          type: 'link',
          content: url,
          href: href
        });
  
        lastIndex = end;
      }
    }
  
    if (lastIndex < text.length) {
      parts.push({ type: 'text', content: text.substring(lastIndex) });
    }
  
    return parts.length > 0 ? parts : [{ type: 'text', content: text }];
  };
  
  const renderedContent = convertUrlsToLinks(content);

  return (
    <div className={`banner-renderer ${className}`}>
      {Array.isArray(renderedContent) ? (
        renderedContent.map((part, index) => {
          if (part.type === 'link') {
            return (
              <a
                key={index}
                href={part.href}
                target="_blank"
                rel="noopener noreferrer"
                className="banner-link"
                onClick={(e) => e.stopPropagation()}
              >
                {part.content}
                <span className="banner-link-icon">🔗</span>
              </a>
            );
          }
          return <span key={index} className="banner-text">{part.content}</span>;
        })
      ) : (
        <span className="banner-text">{content}</span>
      )}
    </div>
  );
};

export default BannerRenderer;